module.exports = __webpack_public_path__ + "img/defaultCarousel.a143384b.jpg";